<template>
  <div class="navbar-container">
    <div :class="'navbar-left-container ' + (type || '')">
      <img alt="logo" :src="imgUrl" class="logo" />
      <div v-if="currentStep > 0 && steps > 2" class="navbar-left-text">
        ONBOARDING
      </div>
    </div>
    <div v-if="stepTitle" class="step-number-container">
      <div class="step-number-items">
        <div
          v-for="(step, index) in getStepArray(steps)"
          :key="index"
          :class="'step-number-item' + (step <= currentStep ? ' selected' : '')"
          :style="'right: ' + (steps - step) * 23 + 'px;'"
        >
          {{ step }}
        </div>
      </div>
      {{ stepTitle }}
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils';
export default {
  name: 'Navbar',
  props: {
    type: String,
    stepTitle: String,
    steps: Number,
    currentStep: Number
  },
  computed: {
    imgUrl() {
      const name = !isMobile() && this.type === 'onboarding' ? 'logo_black' : 'logo';
      const images = require.context('@/assets/images', false, /\.svg$/);
      return images('./' + name + '.svg');
    }
  },
  methods: {
    getStepArray(step) {
      const arr = [];
      for (let i = step; i >= 1; i--) {
        arr.push(i);
      }
      return arr;
    }
  }
};
</script>

<style scoped lang="scss">
.navbar-container {
  position: relative;
  width: 100%;
  height: 85px;
  min-height: 85px;
  background-color: #ffffff;
  padding: 0px 4%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .navbar-left-container {
    display: flex;
    flex-direction: row;
    align-items: center;

    &.onboarding {
      opacity: 0.65;
    }

    .logo {
      width: 110px;
      height: 32px;
      margin-right: 15px;
    }

    .navbar-left-text {
      font-family: Inter;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 25px;
      letter-spacing: 0.3em;
      color: #000000;
    }
  }

  .step-number-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
    color: $colorTitle;

    .step-number-items {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 20px;
      position: relative;

      .step-number-item {
        position: absolute;
        width: 30px;
        height: 30px;
        background: #ced1d8;
        border: 2px solid #ffffff;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: Inter;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 25px;
        text-align: center;
        letter-spacing: -0.01em;
        color: #ffffff;

        &.selected {
          background: #77a9d7;
        }
      }
    }
  }

  @media (min-width: 320px) and (max-width: 480px) {
    background: #ffffff;
    height: 55px;
    min-height: 55px;

    .navbar-left-text {
      display: none;
    }

    .step-number-container {
      display: none;
    }
  }
}
</style>
